<template>
  <div class="party-list-wrapper" v-loading="loading">
    <ul v-if="partyAcList.length > 0">
      <li class="item" v-for="(item, index) in partyAcList" :key="index">
        <router-link :to="`content/${item.articleid}`" class="img-box">
          <img :src="item.photo" alt="" srcset="" />
        </router-link>
        <div class="content-box">
          <router-link :to="`content/${item.articleid}`" class="title">
            {{ item.title }}
          </router-link>
          <p class="digest">{{ item.summary }}</p>
          <p class="info">
            <span class="author">{{ item.author }}</span>
            <!-- <i class="line">|</i> -->
            <span class="date">{{ item.issue_time }}</span>
          </p>
        </div>
      </li>
    </ul>
    <div class="no-data" v-else>
      暂无数据
    </div>
  </div>
</template>
<script>
export default {
  name: 'party-list',
  data() {
    return {
      partyAcList: [],
      loading: false
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    async requestList() {
      this.loading = true;
      try {
        const res = await this.$http.post('cg/commonRequest', {
          method: 'pinfo.party.building.list',
          token: ''
        });
        if (res.code === 200) {
          this.partyAcList = res.data;
          this.partyAcList.forEach(x => {
            x.issue_time = x.issue_time.split(' ')[0];
          });
          this.loading = false;
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.party-list-wrapper {
  padding: 0px 70px 20px;
  ul {
    min-height: 300px;
  }
  .item {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px dashed #ccc;
    height: 190px;
    .img-box {
      display: block;
      width: 250px;
      height: 150px;
      margin-right: 30px;
      background: #ccc;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content-box {
      flex: 1;
      line-height: 32px;
      .title {
        color: #4f90f5;
        font-size: 20px;
        color: #333333;
      }
      .info {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #999999;
      }
      .digest {
        // text-indent: 2em;
        font-size: 14px;
        color: #333333;
        line-height: 28px;
        margin: 10px 0;
      }
    }
  }
  .no-data {
    text-align: center;
    font-size: 30px;
    line-height: 300px;
    color: #ccc;
    background: #fff;
  }
}
</style>
